export var ForceFullSyncObject;
(function (ForceFullSyncObject) {
    ForceFullSyncObject[ForceFullSyncObject["APPROVAL"] = 0] = "APPROVAL";
    ForceFullSyncObject[ForceFullSyncObject["CLASS"] = 1] = "CLASS";
    ForceFullSyncObject[ForceFullSyncObject["CONTRACT"] = 2] = "CONTRACT";
    ForceFullSyncObject[ForceFullSyncObject["COSTTYPE"] = 3] = "COSTTYPE";
    ForceFullSyncObject[ForceFullSyncObject["CUSTOMER"] = 4] = "CUSTOMER";
    ForceFullSyncObject[ForceFullSyncObject["DEPARTMENT"] = 5] = "DEPARTMENT";
    ForceFullSyncObject[ForceFullSyncObject["ITEM"] = 6] = "ITEM";
    ForceFullSyncObject[ForceFullSyncObject["LOCATION"] = 7] = "LOCATION";
    ForceFullSyncObject[ForceFullSyncObject["PROJECT"] = 8] = "PROJECT";
    ForceFullSyncObject[ForceFullSyncObject["PROJECTRESOURCE"] = 9] = "PROJECTRESOURCE";
    ForceFullSyncObject[ForceFullSyncObject["PROJECTSTATUS"] = 10] = "PROJECTSTATUS";
    ForceFullSyncObject[ForceFullSyncObject["TASK"] = 11] = "TASK";
    ForceFullSyncObject[ForceFullSyncObject["TASKRESOURCE"] = 12] = "TASKRESOURCE";
    ForceFullSyncObject[ForceFullSyncObject["TIMESHEET"] = 13] = "TIMESHEET";
    ForceFullSyncObject[ForceFullSyncObject["TIMESHEETENTRY"] = 14] = "TIMESHEETENTRY";
    ForceFullSyncObject[ForceFullSyncObject["TIMETYPE"] = 15] = "TIMETYPE";
    ForceFullSyncObject[ForceFullSyncObject["VENDOR"] = 16] = "VENDOR";
    ForceFullSyncObject[ForceFullSyncObject["WAREHOUSE"] = 17] = "WAREHOUSE";
    ForceFullSyncObject[ForceFullSyncObject["EMPLOYEEPOSITION"] = 18] = "EMPLOYEEPOSITION";
    ForceFullSyncObject[ForceFullSyncObject["LABORCLASS"] = 19] = "LABORCLASS";
    ForceFullSyncObject[ForceFullSyncObject["LABORSHIFT"] = 20] = "LABORSHIFT";
    ForceFullSyncObject[ForceFullSyncObject["LABORUNION"] = 21] = "LABORUNION";
    ForceFullSyncObject[ForceFullSyncObject["FIXEDASSET"] = 22] = "FIXEDASSET";
    ForceFullSyncObject[ForceFullSyncObject["ALLOCATION_TEMPLATE"] = 23] = "ALLOCATION_TEMPLATE";
})(ForceFullSyncObject || (ForceFullSyncObject = {}));
//# sourceMappingURL=force-full-sync-object.js.map